<template>
    <header class="md:ut-flex md:ut-justify-between ut-px-6 ut-py-8 ut-relative">
      <div class="ut-ml-0 md:ut-flex md:ut-justify-between ut-text-left">
        <svg-loader :name="'icon-pin'"
              :width="24"
              :color-class="'ut-text-neutral-400'"
              class="ut-mr-6 md:ut-mb-auto ut-mb-5 ut-inline-block" />
        <h3 class="ut-text-xl ut-text-neutral-900">{{ address || 'Address unknown' }}</h3>
        <tooltip-info-circle v-if="address === 'Active near your agency'"
              :tooltipContent="'No address available in your CRM'" />
      </div>
      <div v-if="consultantName"
           class="md:ut-m-auto md:ut-mr-0 ut-flex md:ut-relative
            ut-content-center ut-absolute ut-top-0 ut-right-0 ut-mr-6 ut-mt-6"
           v-tooltip="{content: 'This vendor was verified via phone by OpenAgent Assistant',
            trigger: 'hover click'}">
        <span class="ut-text-sm ut-text-green-400 ut-mr-2">{{ consultantName }}</span>
        <svg-loader name="icon-shield"
              :width="22"
              :height="22"
              :color-class="'ut-text-green-300'" />
      </div>
      <div v-if="address === 'Active near your agency'" class="ut-text-xs ut-mr-0 ut-text-green-300"
        v-gaEvent="{ category: gacategory, action: 'Contact card - more information OA Match' }"
        @click.stop="navigateToProspectOAMatchActivity()">
        <u>More information</u>
      </div>
    </header>
</template>
<script>
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';
import TooltipInfoCircle from '@/components/TooltipInfoCircle.vue';

export default {
  name: 'ProspectCardHeader',
  components: {
    SvgLoader,
    TooltipInfoCircle,
  },
  props: {
    address: {
      type: String,
      required: false,
    },
    consultantName: {
      type: String,
      required: false,
      default: null,
    },
    consultantImg: {
      type: String,
      required: false,
      default: null,
    },
    prospectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal'
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    navigateToProspectOAMatchActivity() {
      console.log("OA Match");
       
      this.$router.push({
        path: `/${this.$route.params.ak}/prospect/${this.prospectKey}`,
        params: { ak: this.$route.params.ak, pk: this.prospectKey },
        hash: this.$route.hash,
        query: { moreinfo: true },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  h3 {
    letter-spacing: -0.25px;
  }
</style>
